import { computed, Injectable, signal } from '@angular/core';

import { classifySelections, InventoryEntityRef } from '@shure/cloud/shared/models/devices';

@Injectable()
export class InventorySelectionService {
	private readonly selectedEntitiesState = signal<readonly InventoryEntityRef[]>([]);
	public readonly selectedEntities = this.selectedEntitiesState.asReadonly();
	public readonly selectionState = computed(() => classifySelections(this.selectedEntities()));

	public readonly selectedDeviceIds = computed(() =>
		this.selectionState() === 'device' ? this.selectedEntities().map((entity) => entity.id) : []
	);
	public readonly selectedGroupIds = computed(() =>
		this.selectionState() === 'group' ? this.selectedEntities().map((entity) => entity.id) : []
	);
	public readonly selectedSpaceIds = computed(() =>
		this.selectionState() === 'space' ? this.selectedEntities().map((entity) => entity.id) : []
	);

	public setSelections(selections: readonly InventoryEntityRef[]): void {
		this.selectedEntitiesState.set(selections);
	}
}
